var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("b", [_vm._v("Services")]),
          _c("v-spacer"),
          !_vm.creating
            ? _c(
                "v-btn",
                {
                  staticClass: "float-sm-right mt-2 mx-2",
                  attrs: { small: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("createReq")
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("mdi-plus-box-outline"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c(
            "v-list",
            [
              _vm.showAlert
                ? _c("Alert", {
                    attrs: { text: "Service updated", type: "success" },
                  })
                : _vm._e(),
              _vm._l(_vm.servicesData, function (service, index) {
                return _c(
                  "v-list-item",
                  {
                    key: service.id,
                    staticClass: "card-shadow border-radius-xl",
                  },
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "4" } },
                              [
                                _c("EditableField", {
                                  attrs: {
                                    value: service.name,
                                    keyPath: `servicesData.${index}.name`,
                                    hideLabel: "",
                                    label: "Name",
                                    editing: _vm.editing[index],
                                  },
                                  on: { save: _vm.updateApiData },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "value",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "mb-0" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [_vm._v(_vm._s(service.name))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("EditableField", {
                                  attrs: {
                                    value: service.url,
                                    keyPath: `servicesData.${index}.url`,
                                    label: "URL",
                                    hideLabel: "",
                                    editing: _vm.editing[index],
                                  },
                                  on: { save: _vm.updateApiData },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "value",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "mb-2" },
                                              [
                                                _c("i", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "https://" +
                                                          service.url,
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(service.url)
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c("v-col", { attrs: { cols: "4" } }),
                            _c(
                              "v-col",
                              { attrs: { cols: "4" } },
                              [
                                !_vm.editing[index]
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "float-sm-right mt-2 mx-2",
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteService(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-trash-can-outline"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "float-sm-right mt-2 mx-2",
                                    attrs: { icon: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleEdit(index)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.editing[index]
                                            ? "mdi-content-save"
                                            : "mdi-account-edit"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm.editing[index]
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass:
                                          "btn-sm float-sm-right mt-2 mx-2",
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.cancelEdit(index)
                                          },
                                        },
                                      },
                                      [_vm._v(" Cancel ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }